<template>
  <OmtLayoutContainer>
    <OmtRow mb="24px">
      <OmtTypography as="h1-bold"> Nova solicitação </OmtTypography>
    </OmtRow>
    <OmtRow mb="16px">
      <OmtTypography as="p1" color="var(--colors-light-primary-gray2)"> Assunto da solicitação </OmtTypography>
    </OmtRow>
    <OmtRow v-if="!loading">
      <Options
        id="optSubjectId"
        name="optSubject"
        :solid="true"
        :preSelected="subjectId"
        :options="subjectOptions"
        :onSelection="onSelectedSubject"
        placeholder="Selecione o assunto"
        class="options-requests"
      />
    </OmtRow>

    <template v-if="!loading && subjectId">
      <OmtRow mt="24px" mb="16px">
        <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">
          Beneficiário que realizará o procedimento
        </OmtTypography>
      </OmtRow>
      <OmtRow>
        <Options
          id="optRecipientId"
          name="optRecipient"
          :solid="true"
          :preSelected="beneficiary"
          :options="beneficiaries"
          :onSelection="onSelectedBeneficiary"
          placeholder="Selecione o Beneficiário"
          class="options-requests"
        />
      </OmtRow>
    </template>
    <template v-if="subjectId">
      <OmtRow mt="10px">
        <div class="notices">
          <CFlex align-items="center">
            <OmtIcons :name="'circle-exclamation'" size="1x" mr="2" color="#4E4E4E" />
            <OmtTypography as="p3">
              <omt-bold>Documentos necessários</omt-bold>
            </OmtTypography>
          </CFlex>
          <CBox mt="4">
            <OmtTypography as="p1" class="release">
              <CBox mb="8px"> Confira os documentos e informações necessárias para a sua solicitação.</CBox>
              <CBox>
                <omt-bold>Lembre-se:</omt-bold> Todas as imagens enviadas devem pertencer ao beneficiário que utilizou o
                serviço.
              </CBox>
            </OmtTypography>
          </CBox>

          <CFlex mt="2">
            <a class="show-all-button" v-on:click.prevent="() => (modalDocuments = true)"> Ver tudo </a>
            <OmtIcons name="angle-right" size="sm" ml="2" color="#172972" />
          </CFlex>
        </div>
      </OmtRow>
    </template>
    <OmtRow mt="48px" justifyContent="center">
      <OmtButton :w="['100%', '308px !important']" @click="next" :disabled="disableButton"> Continuar </OmtButton>
    </OmtRow>
    <DocumentsModal
      :indexOpen="indexOpen"
      :subject="this.subject.outros"
      :subjectOptions="subjectOptions"
      :isOpen="modalDocuments"
      @close="closeModal()"
    />
  </OmtLayoutContainer>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import Options from "@/components/Molecules/Options";
import DocumentsModal from "@/components/Organisms/Requests/NecessaryDocumentsModal.vue";
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";

export default {
  name: "CreateRequest",
  components: {
    Options,
    DocumentsModal,
    FixedButtonRow
  },
  data() {
    return {
      beneficiary: "",
      loading: true,
      modalDocuments: false,
      subjectId: 0,
      subject: {}
    };
  },
  computed: {
    ...mapState("request", ["addPermission", "beneficiaries", "newRequest", "subjectOptions"]),
    ...mapState("saude", ["vinculo"]),
    queryOrder() {
      return this.$route.query?.tipo === "pedido" ?? "";
    },
    queryOthers() {
      return this.$route.query?.outros ?? "";
    },
    attchamentDsc() {
      if (!this.subject?.attchamentDsc?.length) return [];
      const showMore = this.subject.attchamentDsc.length > 2;
      const attchamentDsc = [...this.subject.attchamentDsc.slice(0, 2).map(a => a.dsc)];
      if (showMore) attchamentDsc[1] = `${attchamentDsc[1]} ...`;
      return attchamentDsc;
    },
    disableButton() {
      if (this.subject?.beneficiaryType) {
        return !this.subjectId || !this.beneficiary;
      }
      return !this.subjectId;
    },
    isOtherMatters() {
      return this.subject?.outros || false;
    },
    indexOpen() {
      return this.subjectId === 7 ? 4 : this.subjectId - 1;
    }
  },
  methods: {
    ...mapActions("request", ["fetchBeneficiaries", "fetchSubjectOptions"]),
    ...mapMutations("request", ["SET_BENEFICIARY", "SET_SUBJECT"]),
    onSelectedSubject(id) {
      if (id) {
        this.subjectId = id;
        this.subject = this.subjectOptions.find(s => s.value === id);
      }
    },
    onSelectedBeneficiary(beneficiary) {
      if (beneficiary) {
        this.beneficiary = beneficiary;
      }
    },
    next() {
      if (this.disableButton) return;
      this.SET_SUBJECT(this.subjectId);
      this.SET_BENEFICIARY(this.subject?.beneficiaryType ? this.beneficiary : "");
      if (this.queryOrder) {
        this.$router.push({ name: "request.upload.documents", query: { tipo: "pedido" } });
        return;
      }
      if (this.subjectId === 7) {
        this.$router.push({
          name: "request.observation.outros",
          params: {
            requireAuth: !!this.subject.authorizationService
          }
        });
        return;
      }
      this.$router.push(this.subject.attchamentType ? "/solicitacoes/upload" : "/solicitacoes/observacao");
    },
    closeModal() {
      this.modalDocuments = false;
    }
  },
  async mounted() {
    let redirect = false;
    try {
      this.$root.$emit("show-loading");
      this.loading = true;
      if (!this.addPermission) this.$router.replace("/solicitacoes");
      await Promise.all([this.fetchBeneficiaries(), this.fetchSubjectOptions()]);
      if (this.newRequest?.subject) this.onSelectedSubject(this.newRequest.subject);
      if (this.newRequest?.beneficiary) this.onSelectedBeneficiary(this.newRequest.beneficiary);

      if (this.queryOrder) {
        const loggedBeneficiary = this.beneficiaries.find(b => {
          return b.id === this.vinculo;
        });

        if (("logado", loggedBeneficiary)) {
          this.onSelectedSubject(1);
          this.onSelectedBeneficiary(loggedBeneficiary.value);
          this.next();
        }
      }

      // Caso tenha query outros e já tenha os dados necessários, redireciona para a página de observação
      if (this.queryOthers && this.newRequest && this.subject) {
        redirect = true;
        this.$router.push({
          name: "request.observation.outros",
          params: {
            requireAuth: !!this.subject.authorizationService
          }
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
      // Caso não tenha redirecionado, esconde o loading
      if (!redirect) this.$root.$emit("hide-loading");
    }
  }
};
</script>

<style scoped>
.notices {
  background-color: #f6f6f9;
  padding: 16px;
  border-radius: 8px;
}

.notices .release {
  line-height: 22px;
}

.list li {
  font-size: 12px;
}

.show-all-button {
  color: #172972;
  font-weight: 700;
  font-size: 14px;
}

.options-requests ::v-deep select {
  font-size: 14px !important;
  font-weight: 700;
}
</style>
